import Cookies from 'js-cookie'
import { fmUserLogin, getVerificationCode, fmUserChangeUserPwd } from '@/view/api/ajax'
import { Message } from 'element-ui'
import SideMenuUtils from '@/utils/sideMenuUtils'
import MenuUtils from '@/utils/menuUtils'

/* ----------------------------------------*/
const sideMenus = []
const routers = []
const fmMenus = []
//
function loginData(data) {
  window.sessionStorage.setItem('menus', JSON.stringify(data))
  MenuUtils(routers, data)
  window.sessionStorage.setItem('sideMenus', JSON.stringify(sideMenus))
}
//
function filterAsyncRouter(routes) {
  let firstPage = {
    menuId: 1,
    parentId: -1,
    menuNameNick: 'page/Index/Index',
    menuName: '我的工作台',
    hasChild: 'N',
    menuDepth: 2,
    childMenus: []
  };
  const sysMenus = []
  // sysMenus.push(firstPage);
  if (routes.menus && routes.menus.childMenus !== null) {
    routes.menus.childMenus.forEach(v => {
      sysMenus.push(v)
    })
  }
  const menu = {
    path: '/',
    menuNameNick: 'layout/Home',
    menuName: 'OMS',
    hasChild: 'Y',
    isRoot: true
  }
  menu.childMenus = []
  for (let i = 0; i < sysMenus.length; i++) {
    if (sysMenus[i].menuDepth === 2) {
      menu.childMenus.push(sysMenus[i])
    }
  }
  SideMenuUtils(sideMenus, menu.childMenus)
  fmMenus.push(menu)
  loginData(fmMenus)
}
/* ----------------------------------------*/
const login = {
  namespaced: true,
  state: {
    addRouters: [],
    clients: [],
    checkedData: null,
    resp: null
  },
  mutations: {
    FM_USER_LOGIN_REQUEST(state, data) {
      state.addRouters = routers
      //
      state.clients = data.clients
      sessionStorage.setItem('clients', JSON.stringify(data.clients))
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    FM_USER_CHANGE_USER_PWD_REQUEST: (state, obj) => {
      state.checkedData = obj
    },
    RESP(state, data){
      state.resp = data
    }
  },
  actions: {
    // 登录请求
    async fmUserLoginRequest({ dispatch, commit }, data) {
      let res = await fmUserLogin(data)
      if (res.code === 200){
        const {code, obj} = res;
        const {refreshToken,token} = obj;
        localStorage.setItem("token", token);
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem("pwdLoginUser", obj.user.remark);
        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST',obj)
        //dispatch('kdOrganization/findAll',{},{root:true});
        //dispatch('kdSortingPlan/findAll',{},{root:true});
      }
    },

    async getVerificationCodeRequest({ dispatch, commit }, data) {
      let res = await getVerificationCode(data);

      commit('RESP', res);

    },
    //
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    async fmUserChangeUserPwdRequest({ commit }, obj) {
      const resp = await fmUserChangeUserPwd(obj)
      commit('FM_USER_CHANGE_USER_PWD_REQUEST', resp)
    }
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js